import { Button } from "components/Button/Button"
import { Divider } from "components/Divider/Divider"
import { Enrollment } from "interface/enrollment"
import { downloadFileFromUrl } from "utils/file"

export const ConsentActions = ({ enrollment }: { enrollment: Enrollment }) => {
	if (!enrollment.consentFormUrl) {
		return null
	}

	return (
		<div className="flex items-center justify-start">
			<Button
				type="link"
				href={enrollment.consentFormUrl}
				target="_blank"
				rel="noopener noreferrer"
				className="h-fit p-0"
			>
				View
			</Button>
			<Divider vertical />
			<Button
				type="link"
				className="h-fit p-0"
				onClick={async () => {
					await downloadFileFromUrl(
						enrollment.consentFormUrl!,
						`signed-consent-form-${enrollment.fullName}`,
					)
				}}
			>
				Download
			</Button>
		</div>
	)
}
